// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Truck from "@insite/mobius/Icons/Truck";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import CustomerDetailsModal from "@store/Library/Widgets/CustomerDetails/CustomerDetailsModal";
import React from "react";
import { css } from "styled-components";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import * as cssLinter from "css";

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import { useIsSignedInAndhasToBeSignedIn } from "@store/Framework/Store/Context/ContextHooks";
import { linkStyles } from "@store/Themes/common/mixins/link";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { toToolkitApplicationState } from "@toolkit/Framework/Store/ApplicationState";

enum fields {
    customCSS = "customCSS",
}
interface CustomerDetailsButtonStyles {
    icon?: IconPresentationProps;
    link?: LinkPresentationProps;
}

const styles: CustomerDetailsButtonStyles = {
    icon: {
        color: "inherit",
        css: css`
            display: flex;
        `,
    },
    link: {
        css: css`
            ${linkStyles("text.darkest", "primary", false, false)};
            padding: 4px;
        `,
    },
};

interface Props extends WidgetProps {
    fields: {
        [fields.customCSS]: string;
    };
}

const CustomerDetailButton: React.FC<Props> = ({ fields }) => {
    const isSignedInAndhasToBeSignedIn = useIsSignedInAndhasToBeSignedIn();
    const session = useAppSelector(state => toToolkitApplicationState(state).context.session);
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const handleModalClick = () => {
        setIsModalOpen(true);
    };

    if (!isSignedInAndhasToBeSignedIn || !session.billToId || !session.shipToId) {
        return null;
    }
    const customCssWrapper = {
        css: css`
            ${fields.customCSS}
        `,
    };
    return (
        <StyledWrapper {...customCssWrapper}>
            <CustomerDetailsModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                customCss={fields.customCSS}
            />
            <Link
                {...styles.link}
                onClick={handleModalClick}
                data-test-selector="customer-details"
                className="customer-details-header-button"
            >
                <Icon src={Truck} {...styles.icon} className="customer-details-header-button-icon" />
            </Link>
        </StyledWrapper>
    );
};

const defaultCustomCss = `& {
}
.customer-details-header-button {
}
.customer-details-header-button-icon {
}
.customer-details-address-wrapper {
}
.customer-details-billing-wrapper {
}
.customer-details-shipping-wrapper {
}
.customer-details-billing-title {
}
.customer-details-shipping-title {
}
.customer-details-horizontal-rule {
}
.customer-details-button-container {
}
.customer-details-change-link {
}
.customer-details-change-button {
}
.customer-details-cancel-button {
}`;

const widgetModule: WidgetModule = {
    component: CustomerDetailButton,
    definition: {
        displayName: "Customer Details Button",
        group: "Common",
        fieldDefinitions: [
            {
                name: "customCSS",
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                defaultValue: defaultCustomCss,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (!result?.stylesheet?.parsingErrors) {
                        return "Unable to parse CSS";
                    }

                    return result.stylesheet.parsingErrors.length === 0
                        ? ""
                        : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0] ||
                              "CSS parsing error";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
